<script setup>
    import { ref, computed, watch } from 'vue'
    import { useScheduleItemStore } from "@/stores/ScheduleItemStore"

    const workshopSelect = ref('')
    const store = useScheduleItemStore()

    const handleSelect = () => {
        store.setCurrentFilter('workshop', workshopSelect.value)
    }

    const workshops = store.workshops

    const matchStore = computed( () => {
        return store.currentFilters.workshop
    })
    watch( matchStore,
        (newValue) => {
            workshopSelect.value = newValue
        },
        { deep: true }
    )

</script>
<template>
    <div class="sles__header__filters__select sles__header__filters__select--ws" :class="store.currentFilters.workshop !== '' ? 'active' : ''">
        <label for="filter_workshop">General Session</label>
        <select 
            name="filter_workshop" 
            id="filter_workshop" 
            v-model="workshopSelect"
            @change="handleSelect"    
        >
            <option value="">--Workshop--</option>
            <option v-for="workshop in workshops" :key="workshop.id" :value="workshop.slug">{{ workshop.ws_name_short }}</option>
        </select>
    </div>
</template>